import getActionCreator from '../libs/getActionCreator';
import actionTypes from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const setCurrentGameTableRef = getActionCreator(actionTypes.SET_CURRENT_GAME_REF);
export const updateCardColor = getActionCreator(actionTypes.UPDATE_CARD_COLOR);
